import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/** Auth requise. Si pas de cabinet actif → page sélection cabinets. */
export default function ProtectedRoute({ children, requireCabinet = true }) {
  const { isAuthenticated, loading, activeCabinet } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
          <p className="mt-2">Vérification de l&apos;authentification...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (requireCabinet && !activeCabinet && location.pathname !== '/cabinets') {
    return <Navigate to="/cabinets" replace />;
  }

  return children;
}
